/* eslint-disable import/extensions */
import { Feature } from '../common'
import { PAGES } from '../../constants/GLOBAL_VARIABLE'

const DROPS_TARGET = 'twitch'

export default class TwitchLinking extends Feature {
  constructor({ mainUrl }) {
    super({ namespace: 'ial', enumKey: 'IAL.TWITCH_LINKING' })
    this.mainUrl = mainUrl || 'https://signin.nexon.com'

    // persistent values
    const {
      gid,
      redirect_uri: redirectUri,
      support_platforms: supportPlatforms,
    } = this.queryParamWithCookie

    // one-time values
    const {
      link_ticket: linkTicket,
      twitch_code: twitchCode,
    } = this.queryParam

    this.gid = gid
    this.target = DROPS_TARGET
    this.redirectUri = redirectUri
    this.supportPlatforms = supportPlatforms
    this.linkTicket = linkTicket
    this.twitchCode = twitchCode

    console.debug('[TwitchLinking Instance]', this)
  }

  get hasLinkTicket() {
    return !!this.linkTicket
  }

  setCookie() {
    const cookieData = {
      gid: this.gid,
      target: this.target,
      redirect_uri: this.redirectUri,
      support_platforms: this.supportPlatforms,
      link_ticket: this.linkTicket,
      twitch_code: this.twitchCode,
    }
    this.namespaceCookie.setCookie(cookieData)
  }

  clearCookie() {
    this.namespaceCookie.clearCookie()
  }

  saveReferrer() {
    const redirect = this.redirectUri ? decodeURIComponent(this.redirectUri) : ''

    if (!(redirect || document.referrer)) return

    const url = new URL(redirect || document.referrer)
    const referrer = url.toString()
    this.redirectUri = referrer
  }

  gotoPlatformSelectorPage() {
    this.navigateToUrlWithoutHistory(`${this.mainUrl}/${PAGES.IAL_TWITCH_PLATFORM_SELECTOR}`)
  }

  gotoAccountInfoPage() {
    this.navigateToUrlWithoutHistory(`${this.mainUrl}/${PAGES.IAL_TWITCH_ACCOUNT_INFO}`)
  }

  processTwitchLinking() {
    this.clearCookie()
    this.saveReferrer()
    this.setCookie()

    if (this.hasLinkTicket) {
      this.gotoPlatformSelectorPage()
    } else {
      this.gotoAccountInfoPage()
    }
  }
}
